/* src/shared/sidebar/SidebarToggle.tsx */
import React, { ButtonHTMLAttributes } from 'react';
import s from './SidebarToggle.module.scss';
import SvgIcon from '@components/shared/icon/svgIcon/SvgIcon';
import { useCompanyTheme } from '@hooks/useCompanyTheme';
import { getCurrentThemeFromDom, getThemeAsset, normalizeTheme } from '@configs/themeAssets'; // импортируешь свой хук

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: string;
}

const SidebarToggle: React.FC<Props> = ({ className = '', ...rest }) => {
  const company = useCompanyTheme();

  // определяем иконку в зависимости от темы компании

  const theme =
    getCurrentThemeFromDom() ??
    normalizeTheme(company) ??
    null;

  const srcLogo = getThemeAsset(theme, 'icon-burger', 'icon-menu');

  if (!srcLogo) return null;

  return (
    <button className={`${s.toggle} ${className}`} {...rest}>
      <SvgIcon name={srcLogo} width={34} height={34} sprite="sprite2" />
    </button>
  );
};

export default SidebarToggle;